import moment from 'moment';

import {unexpectedCase, getRehydratedValueForDateProperty} from 'nutshell-core/reducer-utils';

import {ACTIVITIES} from '../master-dashboard/dashboard-constants';
import type {ActivitiesTabKey, TodosTabKey} from '../master-dashboard/dashboard-constants';

// @ts-expect-error
import {ActionTypes as SidebarActionTypes, SidebarAction} from './sidebar-actions';

export type SidebarState = {
    activeView: ActivitiesTabKey | TodosTabKey;
    displayDate: number; // unix milliseconds,
    lastUpdated: number; // unix milliseconds
};

const sidebarDefaultState = {
    activeView: ACTIVITIES,
    displayDate: moment().startOf('day').valueOf(),
    lastUpdated: 0,
} as const;

// This reducer is responsible for ui-level concerns, such as the calendar date,
// which tab in the calendar is selected, etc.
export const sidebarReducer = (
    state: SidebarState | null | undefined = sidebarDefaultState,
    action: SidebarAction
): SidebarState => {
    switch (action.type) {
        case SidebarActionTypes.SIDEBAR_CALENDAR_ACTIVE_VIEW_UPDATED: {
            // @ts-expect-error
            return {
                ...state,
                activeView: action.payload,
            };
        }
        case SidebarActionTypes.SIDEBAR_CALENDAR_DISPLAY_DATE_UPDATED: {
            // @ts-expect-error
            return {
                ...state,
                displayDate: action.payload,
                lastUpdated: new Date().getTime(),
            };
        }
        // @ts-expect-error
        case 'persist/REHYDRATE': {
            // @ts-expect-error
            const persistedState = action.payload;

            if (!persistedState || !persistedState.ui || !persistedState.ui.sidebar) {
                // @ts-expect-error
                return state;
            }

            return {
                ...state,
                displayDate: getRehydratedValueForDateProperty(
                    persistedState.ui.sidebar,
                    'displayDate'
                ),
                lastUpdated: persistedState.ui.sidebar.lastUpdated,
                activeView: persistedState.ui.sidebar.activeView,
            };
        }
        default:
            // @ts-expect-error
            unexpectedCase(action.type);

            // @ts-expect-error
            return state;
    }
};
